// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"styles_ldsRing__2Llk0"};